import { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { HICLoading } from 'hic-components'
import { routes } from './routes'
import { PublicPageLayout } from '../layout/public-page/public-page.layout'
import { PrivatePageLayout } from '../layout/private-page/private-page.layout'
import { useAuth } from '../hooks/auth/auth.hook'
import { IfGranted } from '../components/authorization'

/**
 * Manage the application routing rules
 * @returns
 */
export const RouterConfig = () => {
  return (
    <Routes>
      {routes.map(({ path, Component, hideToolbar, hideMenu, disableMenu, isPublic, permissions }) => {
        if (isPublic)
          return (
            <Route
              path={path}
              key={path}
              element={
                <PublicPageLayout>
                  <Suspense fallback={<HICLoading />}>
                    <Component />
                  </Suspense>
                </PublicPageLayout>
              }
            ></Route>
          )
        else
          return (
            <Route
              path={path}
              key={path}
              element={
                <RequireAuth from={path}>
                  <PrivatePageLayout hideToolbar={hideToolbar} hideMenu={hideMenu} disableMenu={disableMenu}>
                    <Suspense fallback={<HICLoading />}>
                      <IfGranted {...permissions}>
                        <Component />
                      </IfGranted>
                    </Suspense>
                  </PrivatePageLayout>
                </RequireAuth>
              }
            />
          )
      })}
    </Routes>
  )
}

/**
 * Check the authentication
 */
const RequireAuth = (props: { children: JSX.Element; from?: string }) => {
  const ignoreFromPath = ['/', '/login']

  const { auth } = useAuth()
  if (auth.loading) {
    return <HICLoading />
  } else if (!auth.isAuthenticated) {
    return <Navigate to={`/login${props.from && !ignoreFromPath.includes(props.from) ? `/?redirectTo=${props.from}` : ''}`} />
  } else {
    return props.children
  }
}
